<template>
  <div>
    <Alert class="error">
      <p>
        Your account has been locked due to multiple invalid login attempts.
        <br />
        Please wait <b v-if="waitFor">{{ waitFor }} minutes</b> before trying to
        access your account.
      </p>
    </Alert>
    <DividerSeparator>
      <DecoratedButton
        @click="reset(false)"
        class="wide short dark-blue"
        fontSize=".8em"
      >
        LOGIN WITH A DIFFERENT ACCOUNT
      </DecoratedButton>
    </DividerSeparator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import moment from "moment";

export default {
  name: "account-locked",
  components: {},
  computed: {
    ...mapGetters("user", {
      isLocked: "isLocked"
    }),
    waitFor() {
      if (this.isLocked) {
        return moment(this.isLocked).diff(moment(), "minutes");
      }

      return false;
    }
  },
  methods: {
    ...mapActions("user", {
      setIsLocked: "setIsLocked"
    }),
    reset() {
      this.setIsLocked(false);
      this.$router.push({ name: this.pages.AUTH_LOGIN });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
